import { render } from "./ObservacoesPedidosExpedidoFaturado.vue?vue&type=template&id=68f4a5b0&scoped=true"
import script from "./ObservacoesPedidosExpedidoFaturado.vue?vue&type=script&lang=js"
export * from "./ObservacoesPedidosExpedidoFaturado.vue?vue&type=script&lang=js"

import "./ObservacoesPedidosExpedidoFaturado.vue?vue&type=style&index=0&id=68f4a5b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f4a5b0"]])

export default __exports__